/**
 * Response fields the API has renamed. A control plane upgrades on its own schedule, so the portal can be
 * served by an API that still sends only the old name; a newer API sends both for a while. Each pair is
 * [current name, old name], camelCased: the current one wins, and the old one is read only when the current
 * one is absent. The old key is then dropped, so the rest of the portal only ever sees the current name.
 *
 * Applied to every camelized response object by `camelKeysShallow` (`_caseTransform.ts`).
 */
const RENAMED_FIELDS: ReadonlyArray<readonly [current: string, old: string]> = [
  // database_images: the protocol release a Hardcharger image serves.
  ['chargewireVersion', 'warpSqlVersion'],
];

export const applyRenamedFields = (record: Record<string, unknown>): Record<string, unknown> => {
  for (const [current, old] of RENAMED_FIELDS) {
    if (!(old in record)) continue;
    if (record[current] === undefined || record[current] === null) record[current] = record[old];
    delete record[old];
  }
  return record;
};
